import React from 'react';
import cx from 'classnames';

import styles from './cartItemQuantity.module.less';

export const CartItemQuantity = ({
  className,
  smallerFont = false,
  ...rest
}: React.HTMLAttributes<HTMLDivElement> & { smallerFont?: boolean }) => {
  return (
    <div
      className={cx(styles.cartItemQuantity, { [styles.smaller]: smallerFont }, className)}
      {...rest}
    />
  );
};
